import { Box, Ghost, Palette } from 'lucide-react'
import { useAppStore } from '@core/store'

/** Como se mostra um conflito ou um tópico BCF no 3D: os elementos com as
 *  suas cores, o resto em fantasma e, se se quiser, uma caixa de corte à
 *  volta. Cada um liga e desliga à parte, e a escolha fica para os
 *  próximos (como o "Display Settings" do Clash Detective do
 *  Navisworks). Rui, 18/10/2026: "um default mode em BCF e conflitos que
 *  fique assim, mas que permita [...] retirar". */
export default function ControlosDoRealce({ contexto }: { contexto: 'conflito' | 'topico' }) {
  const realce = useAppStore((s) => s.realce)
  const setRealce = useAppStore((s) => s.setRealce)
  const alvo = contexto === 'conflito' ? 'do conflito' : 'do tópico'
  const botoes = [
    {
      chave: 'cores' as const,
      icone: Palette,
      rotulo: 'Cores',
      dica: `Pinta os elementos ${alvo} com cores próprias (A e B nos conflitos).`,
    },
    {
      chave: 'fantasma' as const,
      icone: Ghost,
      rotulo: 'Fantasma',
      dica: `Põe o resto do modelo em fantasma, para os elementos ${alvo} não ficarem tapados.`,
    },
    {
      chave: 'caixa' as const,
      icone: Box,
      rotulo: 'Caixa',
      dica: `Liga uma caixa de corte à volta dos elementos ${alvo}.`,
    },
  ]
  return (
    <span className="inline-flex flex-wrap items-center gap-1" data-campo="controlos-do-realce">
      {botoes.map(({ chave, icone: Icone, rotulo, dica }) => (
        <button
          key={chave}
          type="button"
          aria-pressed={realce[chave]}
          onClick={() => setRealce({ [chave]: !realce[chave] })}
          title={`${dica} ${realce[chave] ? 'Ligado: clique para tirar.' : 'Desligado: clique para pôr.'} Fica assim para os próximos.`}
          className={`flex items-center gap-1 rounded border px-1.5 py-0.5 text-[11px] ${
            realce[chave]
              ? 'border-[var(--color-accent-border)] bg-[var(--color-accent-bg)] text-[var(--color-accent)]'
              : 'border-[var(--color-border)] text-[var(--color-text-muted)] hover:text-[var(--color-text)]'
          }`}
        >
          <Icone size={12} aria-hidden />
          {rotulo}
        </button>
      ))}
    </span>
  )
}
